<template>
  <div>
    <secondHeader />
    <div class="ct-main">
      <sidebar />
      <div class="ct-content-wrapper">
        <div class="ct-page-header">
          <h1 class="ct-page-title">クリック数テスト</h1>
          <p class="ct-page-description">
            制限時間内にできるだけ多くクリック！<br />
            あなたの連打速度を測定します。
          </p>
        </div>
        <div class="ct-click-test-container">
          <div class="ct-test-wrapper">
            <!-- 状態: 時間選択 -->
            <div v-if="state === 'time_select'" class="ct-time-select-area">
              <h2>時間を選択してください</h2>
              <div class="ct-time-buttons">
                <button @click="selectTime(10)" class="ct-time-button">
                  <span class="ct-time-number">10</span>
                  <span class="ct-time-label">秒</span>
                  <span class="ct-time-desc">お手軽</span>
                </button>
                <button @click="selectTime(30)" class="ct-time-button">
                  <span class="ct-time-number">30</span>
                  <span class="ct-time-label">秒</span>
                  <span class="ct-time-desc">標準</span>
                </button>
                <button @click="selectTime(60)" class="ct-time-button">
                  <span class="ct-time-number">60</span>
                  <span class="ct-time-label">秒</span>
                  <span class="ct-time-desc">本格</span>
                </button>
              </div>
            </div>

            <!-- 状態: 開始待ち -->
            <div
              v-if="state === 'waiting'"
              class="ct-test-area ct-is-waiting ct-pulsing"
              @click="startTest"
            >
              <div class="ct-content">
                <h1>クリックして開始</h1>
                <p class="ct-time-info">{{ selectedTime }}秒間でチャレンジ！</p>
              </div>
            </div>

            <!-- 状態: カウントダウン -->
            <div v-if="state === 'countdown'" class="ct-test-area ct-is-countdown">
              <div class="ct-content">
                <h1 class="ct-countdown-text">{{ countdownNumber }}</h1>
              </div>
            </div>

            <!-- 状態: 測定中 -->
            <div v-if="state === 'testing'" class="ct-test-area ct-is-testing" @click="handleClick">
              <div class="ct-content">
                <h1>連打！</h1>
                <p class="ct-click-count">{{ clickCount }}</p>
                <p class="ct-time-remaining">残り {{ timeRemaining }}秒</p>
              </div>
            </div>

            <!-- 状態: 結果表示 -->
            <div v-if="state === 'result'" class="ct-test-area ct-is-result">
              <div class="ct-result-card">
                <h2>結果</h2>
                <p class="ct-total-clicks">{{ clickCount }} クリック</p>
                <p class="ct-cps">CPS: {{ cps }}</p>
                <p class="ct-rank" :style="{ color: rank.color }">
                  ランク: {{ rank.name }}
                </p>
                <p class="ct-comment">{{ rank.comment }}</p>
                <p class="ct-trivia">豆知識: 一般的なCPSは6〜8だよ！</p>
              </div>
            </div>

            <div v-if="state === 'result'" class="ct-button-container">
              <button @click="reset" class="ct-reset-button">もう一度挑戦</button>
              <button @click="share" class="ct-tweet-button">
                結果をシェアする
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue";

export default {
  name: "ClickTest",
  components: {
    secondHeader,
    sidebar,
  },
  data() {
    return {
      state: "time_select", // time_select, waiting, countdown, testing, result
      selectedTime: 0,
      countdownNumber: 3,
      clickCount: 0,
      timeRemaining: 0,
      startTime: null,
      endTime: null,
      testInterval: null,
      countdownInterval: null,
      rafId: null, // requestAnimationFrame ID
      cps: 0,
    };
  },
  computed: {
    rank() {
      if (this.cps === 0) return {};

      const ranks = {
        "S+": {
          name: "S+",
          comments: [
            "神速の指！もはや機械の域です！",
            "光の速さ！指が見えません！",
            "連打の神降臨！",
          ],
          color: "#ff4757",
        },
        S: {
          name: "S",
          comments: [
            "クリック職人！素晴らしい技術です！",
            "超高速連打！お見事です！",
            "指先の魔術師ですね！",
          ],
          color: "#ffa502",
        },
        A: {
          name: "A",
          comments: [
            "連打マスター！かなりの実力です！",
            "高速クリック！素晴らしい！",
            "指の動きが鋭い！",
          ],
          color: "#2ed573",
        },
        B: {
          name: "B",
          comments: [
            "指先器用！なかなかの速さです！",
            "安定した連打力！",
            "良いリズムですね！",
          ],
          color: "#1e90ff",
        },
        C: {
          name: "C",
          comments: [
            "平均的な速さです！",
            "まずまずの連打力！",
            "練習すればもっと速くなりそう！",
          ],
          color: "#7f8fa6",
        },
        D: {
          name: "D",
          comments: [
            "のんびり派ですね！",
            "マイペースが一番！",
            "指に優しい速度です！",
          ],
          color: "#a4b0be",
        },
      };

      let resultRank;
      if (this.cps >= 15)       resultRank = ranks["S+"];
      else if (this.cps >= 12) resultRank = ranks["S"];
      else if (this.cps >= 9)  resultRank = ranks["A"];
      else if (this.cps >= 7)  resultRank = ranks["B"];
      else if (this.cps >= 5)  resultRank = ranks["C"];
      else                     resultRank = ranks["D"];
      
      const randomIndex = Math.floor(Math.random() * resultRank.comments.length);
      const selectedComment = resultRank.comments[randomIndex];

      return {
        name: resultRank.name,
        comment: selectedComment,
        color: resultRank.color,
      };
    },
  },
  methods: {
    selectTime(seconds) {
      this.selectedTime = seconds;
      this.state = "waiting";
    },
    startTest() {
      this.state = "countdown";
      this.countdownNumber = 3;
      this.countdownInterval = setInterval(() => {
        this.countdownNumber--;
        if (this.countdownNumber <= 0) {
          clearInterval(this.countdownInterval);
          this.beginTesting();
        }
      }, 1000);
    },
    beginTesting() {
      this.state = "testing";
      this.clickCount = 0;
      this.timeRemaining = this.selectedTime;
      
      // より高精度な時間測定を開始
      this.rafId = requestAnimationFrame(() => {
        this.startTime = performance.now();
        this.endTime = this.startTime + (this.selectedTime * 1000);
        this.updateTimer();
      });
    },
    updateTimer() {
      const now = performance.now();
      const remaining = Math.max(0, this.endTime - now);
      this.timeRemaining = Math.ceil(remaining / 1000);
      
      if (remaining > 0) {
        this.rafId = requestAnimationFrame(() => this.updateTimer());
      } else {
        this.endTest();
      }
    },
    handleClick() {
      if (this.state === "testing") {
        const now = performance.now();
        // テスト時間内のクリックのみカウント
        if (now <= this.endTime) {
          this.clickCount++;
        }
      }
    },
    endTest() {
      cancelAnimationFrame(this.rafId);
      const actualDuration = (this.endTime - this.startTime) / 1000;
      this.cps = parseFloat((this.clickCount / actualDuration).toFixed(2));
      this.state = "result";
    },
    reset() {
      clearInterval(this.testInterval);
      clearInterval(this.countdownInterval);
      cancelAnimationFrame(this.rafId);
      this.state = "time_select";
      this.selectedTime = 0;
      this.countdownNumber = 3;
      this.clickCount = 0;
      this.timeRemaining = 0;
      this.startTime = null;
      this.endTime = null;
      this.testInterval = null;
      this.countdownInterval = null;
      this.rafId = null;
      this.cps = 0;
    },
    share() {
      const text = `${this.selectedTime}秒間で【${this.clickCount}クリック】達成！CPS: ${this.cps}、ランクは【${this.rank.name}】でした！\nみんなで挑戦しよう！`;
      const url = window.location.href;
      const hashtags = "はいしんツールキット,クリック数テスト";
      const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}&hashtags=${encodeURIComponent(hashtags)}`;
      window.open(twitterUrl, "_blank");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c:wght@400;700&display=swap");

.ct-main {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}

.ct-content-wrapper {
  flex-grow: 1;
  padding: 40px 20px;
  background-color: #f0f4f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.ct-page-header {
  text-align: center;
  margin-bottom: 30px;
  max-width: 800px;
}

.ct-page-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #3d3d3d;
  margin-bottom: 10px;
}

.ct-page-description {
  font-size: 1.1rem;
  color: #596275;
  line-height: 1.6;
}

.ct-click-test-container {
  font-family: "M PLUS Rounded 1c", sans-serif;
  color: #596275;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.ct-test-wrapper {
  text-align: center;
}

.ct-time-select-area {
  background-color: white;
  border-radius: 30px;
  padding: 3rem;
  border: 4px solid #e0e4e8;
  margin-bottom: 2rem;
}

.ct-time-select-area h2 {
  color: #3d3d3d;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.ct-time-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.ct-time-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  background-color: #ffc0cb;
  border: 4px solid #ff9aab;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "M PLUS Rounded 1c", sans-serif;
  min-width: 120px;
}

.ct-time-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 192, 203, 0.4);
}

.ct-time-button:active {
  transform: translateY(0);
}

.ct-time-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #3d3d3d;
}

.ct-time-label {
  font-size: 1.2rem;
  color: #596275;
  margin-bottom: 0.5rem;
}

.ct-time-desc {
  font-size: 0.9rem;
  color: white;
  font-weight: 500;
}

.ct-test-area {
  width: 100%;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  user-select: none;
  padding: 1rem;
  box-sizing: border-box;
  position: relative;
  border: 4px solid #dcdde1;
  transition: all 0.2s ease;
}

.ct-content {
  text-align: center;
}

.ct-time-info {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 1rem;
}

.ct-click-count {
  font-size: 4rem;
  font-weight: 700;
  color: white;
  margin: 1rem 0;
}

.ct-time-remaining {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.8);
}

.ct-countdown-text {
  font-size: 8rem !important;
  font-weight: 700;
  color: white;
  animation: countdown-pulse 1s infinite;
}

@keyframes countdown-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 状態ごとのスタイル */
.ct-test-area.ct-is-waiting {
  background-color: #ffc0cb;
  border-color: #ff9aab;
}

.ct-test-area.ct-is-countdown {
  background-color: #ffa502;
  border-color: #ff7f00;
  cursor: default;
}

.ct-test-area.ct-is-testing {
  background-color: #2ed573;
  border-color: #25b864;
}

.ct-test-area.ct-is-testing:active {
  transform: scale(0.98);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.01); }
  100% { transform: scale(1); }
}

.ct-test-area.ct-pulsing h1 {
  animation: pulse 2s infinite ease-in-out;
}

.ct-test-area.ct-is-result {
  background-color: transparent;
  border-color: transparent;
  cursor: default;
}

.ct-result-card {
  background-color: white;
  padding: 2rem 3rem;
  border-radius: 20px;
  max-width: 100%;
  margin: 0 auto;
  border: 4px solid #ffc0cb;
  animation: result-appear 0.5s ease-out;
}

@keyframes result-appear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h2 {
  color: #3d3d3d;
  margin-bottom: 1rem;
}

.ct-total-clicks {
  font-size: 3rem;
  font-weight: 700;
  color: #ff6b81;
  margin-bottom: 0.5rem;
}

.ct-cps {
  font-size: 2rem;
  font-weight: 700;
  color: #2ed573;
  margin-bottom: 1rem;
}

.ct-rank {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.ct-comment {
  font-size: 1rem;
  color: #596275;
  margin-bottom: 1.5rem;
}

.ct-trivia {
  font-size: 0.9rem;
  color: #a4b0be;
  margin-bottom: 1.5rem;
  padding: 0.5em 1em;
  border: 2px solid #f0f4f8;
  border-radius: 10px;
  display: inline-block;
}

.ct-button-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.ct-reset-button, .ct-tweet-button {
  padding: 1rem 1.5rem;
  border: 0;
  border-radius: 50px;
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  font-family: "M PLUS Rounded 1c", sans-serif;
  cursor: pointer;
  transition: transform 0.1s ease;
  border-bottom: 4px solid rgba(0, 0, 0, 0.2);
}

.ct-reset-button:active, .ct-tweet-button:active {
  transform: translateY(2px);
  border-bottom-width: 2px;
}

.ct-reset-button {
  background-color: #ff6b81;
}

.ct-tweet-button {
  background-color: #1DA1F2;
}

@media screen and (max-width: 768px) {
  .ct-time-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .ct-time-button {
    width: 100%;
    max-width: 200px;
  }
  
  .ct-result-card {
    padding: 1.5rem;
  }
  
  .ct-total-clicks {
    font-size: 2.5rem;
  }
  
  .ct-cps {
    font-size: 1.5rem;
  }
  
  .ct-rank {
    font-size: 1.5rem;
  }
  
  .ct-comment {
    font-size: 0.9rem;
  }
  
  .ct-reset-button, .ct-tweet-button {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
  
  .ct-button-container {
    flex-direction: column;
  }
}
</style> 